import { Box } from "@chakra-ui/react";
import FormEndereco from "components/FormEndereco";
import CollapseSwitch from "components/CollapseSwitch";

function FormEmpresa({
  control,
  watch,
  setField,
}: {
  control: any;
  watch: any;
  setField: any;
}) {
  return (
    <>
      <CollapseSwitch
        onChange={(v) => {
          setField("moraForaCondominio", v);
          setField("endereco", undefined);
        }}
        open={!!watch("moraForaCondominio")}
        title="Mora fora do condomínio"
      >
        {watch("moraForaCondominio") ? (
          <Box mt="16px">
            <FormEndereco control={control} setField={setField} watch={watch} />
          </Box>
        ) : null}
      </CollapseSwitch>
    </>
  );
}

export default FormEmpresa;
